import { render, staticRenderFns } from "./MozSearchBtn.vue?vue&type=template&id=1c22a116&scoped=true&"
import script from "./MozSearchBtn.vue?vue&type=script&lang=js&"
export * from "./MozSearchBtn.vue?vue&type=script&lang=js&"
import style0 from "./MozSearchBtn.vue?vue&type=style&index=0&id=1c22a116&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c22a116",
  null
  
)

export default component.exports